<script lang="ts">
	import BreakPoint from '$lib/components/BreakPoint/BreakPoint.svelte';
	import SparqFooter from '$lib/components/SparqFooter/SparqFooter.svelte';
	import ParallaxHeader from '$lib/components/cover/ParallaxHeader.svelte';
	import PostSlab from '../Post/Tile/PlaceHolder.svelte';
	import { getHubStores } from '$lib/stores/hubStores';

	const { hub } = getHubStores();
	const slabsArray = new Array(4);
</script>

<div class="container">
	<ParallaxHeader {hub} />
	<div class="nav" />
	<BreakPoint>
		<div class="placeHolders">
			{#each slabsArray as _}
				<PostSlab />
			{/each}
			<slot />
		</div>
	</BreakPoint>
</div>
<SparqFooter />

<style>
	.container {
		block-size: 100vh;
		overflow: hidden;
		background-color: var(--grayLighter);
	}

	.placeHolders {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.nav {
		position: relative;
		block-size: 40px;
		background-color: #fff;
		box-shadow: 0 1px 3px rgb(0 0 0 / 10%);
	}
</style>
